import { useState, useEffect } from "react";

import moment from "moment";
import Loader from "../../../presentationals/Loader/Loader.component";
import { InitalDateFn } from "../../../../utils/commonUtility";
import {
  getAggreatorList,
  getEventListByDateRange,
} from "../../Admin/AdminActionCreator.component";
import { ChevronLeft } from "lucide-react";
import DateFilterSelect from "../../../CustomDatePicker/DateFilterSelectold";

export default function Event({ handleBack, handleFilter, commonFilter }) {
  const [loader, setLoader] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [aggregatorList, setAggregatorList] = useState([]);
  const [selectedAggregator, setSelectedAggregator] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(totalCount / itemsPerPage);
  const [dateFilterPopup, setDateFilterPopup] = useState({ show: false, from: moment().subtract(6, 'days').format("YYYY-MM-DD"), to: moment(new Date).format("YYYY-MM-DD") })

  const [isFilterCleared, setIsFilterCleared] = useState(false);

  useEffect(() => {
    if (
      commonFilter?.fromDate !== dateFilterPopup.from ||
      commonFilter?.toDate !== dateFilterPopup.to
    ) {
      setDateFilterPopup((prev) => ({
        ...prev,
        from: commonFilter.fromDate,
        to: commonFilter.toDate
      }));
    }
    const obj = { from: commonFilter.fromDate, to: commonFilter.toDate }
    getEventListApi(obj, 1);
  }, [commonFilter]);


  const handleApplyDteFilter = () => {
    handleDateFilterPopup("show", false);
  };

  useEffect(() => {
    getAggreatorList((res) => {
      setAggregatorList(res || []);
    });
  }, []);

  // useEffect(() => {
  //   getEventListApi(dateFilterPopup,page);
  // }, [page]);

  const getEventListApi = (customDate, pages) => {
    const sDate = moment(customDate?.from).format("DD-MM-YYYY");
    const eDate = moment(customDate?.to).format("DD-MM-YYYY");

    setLoader(true);

    getEventListByDateRange(
      sDate,
      eDate,
      selectedAggregator,
      pages,
      itemsPerPage,
      (res) => {
        setTableData(res?.data?.data || []);
        setTotalCount(res?.data?.totalCount || 0);
        setLoader(false);
      },
    );
  };

  const handleAggregatorChange = (value) => {
    setSelectedAggregator(value);
    setPage(1);
    getEventListApi(dateFilterPopup, 1);
  };

  const handleDateFilterPopup = (type, val) => {
    const formatted = moment(val).format("YYYY-MM-DD");

    setDateFilterPopup((prev) => {
      if (prev[type] === formatted) return prev; // prevent useless update

      return {
        ...prev,
        [type]: formatted
      };
    });

    if (type === "from") {
      if (commonFilter.fromDate !== formatted) {
        handleFilter("fromDate", formatted);
      }
    } else {
      if (commonFilter.toDate !== formatted) {
        handleFilter("toDate", formatted);
      }
    }
  };

  const handleApply = () => {
    setPage(1);
    getEventListApi(dateFilterPopup, 1);
  };

  const handleReset = () => {
    const today = moment().format("YYYY-MM-DD");
    setIsFilterCleared(true);
    setPage(1);
    setDateFilterPopup({
      show: false,
      from: today,
      to: today,
    });

    getEventListApi({ today, today }, 1);
    setTimeout(() => setIsFilterCleared(false), 0);
  };

  const handleNext = () => {
    if (page < totalPages) {
      getEventListApi(dateFilterPopup, (page + 1));
      setPage((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (page > 1) {
      getEventListApi(dateFilterPopup, (page - 1));
      setPage((prev) => prev - 1);
    }
  };

  const customMarginTop = window.innerWidth > 1800 ? "60px" : "30px";

  return (
    <>
      {loader && <Loader />}

      <div className="OverView-Main-Section min-size-marketing-1800">
        <div className="HeadingFilter-Section">
          <h4
            onClick={handleBack}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              cursor: "pointer",
            }}
          >
            <ChevronLeft /> Events
          </h4>
        </div>

        <div
          className="HeadingFilter-main-filters"
          style={{ marginTop: customMarginTop }}
        >
          <div className="row">
            <div className="col-xl-4 col-md-3 col-xs-12">
              <select
                className="customSelectBox"
                value={selectedAggregator}
                onChange={(e) => handleAggregatorChange(e.target.value)}
                style={{
                  width: "100%",
                  marginTop: "5px",
                  height: "31px",
                }}
              >
                <option value="">Select Aggregator</option>

                {aggregatorList && aggregatorList?.length > 0
                  ? aggregatorList?.map((val, id) => {
                    return (
                      <option value={val?.aggregatorId}>
                        {val?.aggregatorName}
                      </option>
                    );
                  })
                  : ""}
              </select>
            </div>
            <div
              className="col-xl-6 col-md-7 col-xs-12"
              style={{ display: "flex", gap: "10px", marginTop: "5px" }}
            >
              {/* <div className="custom-popup" style={{ width: "30%" }}>
                <div
                  className="customSelectBox "
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "20px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    handleDateFilterPopup("show", !dateFilterPopup?.show)
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "7px",
                      alignItems: "center",
                    }}
                  >
                    <svg
                      width="9"
                      height="9"
                      viewBox="0 0 9 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6 0.75V2.25M3 0.75V2.25"
                        stroke="#0C0B10"
                        stroke-width="0.5625"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M4.875 1.5H4.125C2.71079 1.5 2.00368 1.5 1.56434 1.93934C1.125 2.37868 1.125 3.08579 1.125 4.5V5.25C1.125 6.6642 1.125 7.37134 1.56434 7.81065C2.00368 8.25 2.71079 8.25 4.125 8.25H4.875C6.2892 8.25 6.99634 8.25 7.43565 7.81065C7.875 7.37134 7.875 6.6642 7.875 5.25V4.5C7.875 3.08579 7.875 2.37868 7.43565 1.93934C6.99634 1.5 6.2892 1.5 4.875 1.5Z"
                        stroke="#0C0B10"
                        stroke-width="0.5625"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M1.125 3.75H7.875"
                        stroke="#0C0B10"
                        stroke-width="0.5625"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    {dateFilterPopup?.from && dateFilterPopup?.to
                      ? `${moment(dateFilterPopup?.from).format("DD MMM YYYY")} - ${moment(dateFilterPopup?.to).format("DD MMM YYYY")}`
                      : "Select Date Range"}
                  </div>
                  <div style={{ marginTop: "-5px" }}>
                    <svg
                      width="8"
                      height="4"
                      viewBox="0 0 8 4"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.375 0.375025C7.375 0.375025 4.79731 3.375 3.875 3.375C2.95263 3.375 0.375 0.375 0.375 0.375"
                        stroke="#686C70"
                        stroke-width="0.75"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                {dateFilterPopup?.show ? (
                  <CustomDateFilter
                    payload={dateFilterPopup}
                    handlechange={handleDateFilterPopup}
                    handleApply={handleApplyDteFilter}
                  />
                ) : (
                  ""
                )}
              </div> */}
              <DateFilterSelect
                value={[new Date(commonFilter.fromDate), new Date(commonFilter.toDate)]}
                onChange={(range) => {
                  handleDateFilterPopup("from", range[0]);
                  handleDateFilterPopup("to", range[1]);
                }}
                isFilterCleared={isFilterCleared}
              />
            </div>
            <div
              className="col-xl-2 col-md-2 col-xs-12 flex justify-content-end"
              style={{ marginTop: "5px" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  justifyContent: window.innerWidth > 1200 ? "end" : "start",
                }}
              >
                <div className="custom-btn" onClick={() => handleApply()}>
                  <i class="fa fa-filter" aria-hidden="true"></i>
                </div>
                <div className="custom-btn" onClick={() => handleReset()}>
                  <i class="fa fa-times" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#f4f4f4" }}>
              <th style={thStyle}>Event Name</th>
              <th style={thStyle}>Mobile</th>
              <th style={thStyle}>Created At</th>
            </tr>
          </thead>

          <tbody>
            {tableData.map((item, index) => {
              let parsedDesc = {};
              try {
                parsedDesc = JSON.parse(item.description || "{}");
              } catch {
                parsedDesc = {};
              }

              return (
                <tr key={index}>
                  <td style={tdStyle}>{item.eventName?.replace(/_/g, " ")}</td>
                  <td style={tdStyle}>{parsedDesc.mobile || "-"}</td>
                  <td style={tdStyle}>
                    {new Date(item.created_at).toLocaleString()}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <button
            style={page === 1 ? disabledBtn : buttonStyle}
            disabled={page === 1}
            onClick={handlePrev}
          >
            Prev
          </button>

          <span>
            Page {page} / {totalPages || 1}
          </span>

          <button
            style={page === totalPages ? disabledBtn : buttonStyle}
            disabled={page === totalPages}
            onClick={handleNext}
          >
            Next
          </button>
        </div>
      </div>
    </>
  );
}

const thStyle = {
  border: "1px solid #ddd",
  padding: "8px",
};

const tdStyle = {
  border: "1px solid #ddd",
  padding: "8px",
};

const buttonStyle = {
  padding: "6px 12px",
  margin: "5px",
  background: "#4f46e5",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
};

const disabledBtn = {
  ...buttonStyle,
  background: "#ccc",
  cursor: "not-allowed",
};
